import { francAll } from 'franc'
import { Post } from 'lib/_types'
import { first } from 'lodash'

export const useLangDetect = () => {
  const supportedLangMap = {
    // lang ISO-639-3 code to what our BE supports
    eng: 'en',
    sco: 'en', // english occassionally mistaken as scots which is highly unlikely and close enough to show to eng users anyway
    jpn: 'ja',
    cmn: 'zh',
    yue: 'zh',
    zho: 'zh',
    nan: 'zh', // many dialect possibilities for chinese, collapse all to 'zh'
    tha: 'th',
    sou: 'th',
    nod: 'th',
    khb: 'th', // many dialect possibilities for thai, collapse all to 'th'
    ind: 'id',
    zlm: 'id', // malay easily confused with indonesian and usually close enough either way
  }

  const getLangCode = (isoCode: string) => {
    return supportedLangMap[isoCode] ?? null
  }

  const detectLang = (postText: string) => {
    // we use franc for language detection: https://github.com/wooorm/franc?tab=readme-ov-file

    let mostLikelyCode

    // remove any embedded URLs, remove hashtags (but keep text after hashtags)
    let cleanedText = postText
      ?.replace(/https?:\/\/[^\s]+/g, '')
      .replace(/#(\w+)/g, '$1')

    // franc accuracy can be quite poor for shorter texts (common in posts)
    // so we repeat the text string if necessary to improve the chances of accurate detection
    if (cleanedText.length < 12) {
      cleanedText = cleanedText + ' ' + cleanedText + ' ' + cleanedText
    }

    const likelyLangs = francAll(cleanedText)

    return getLangCode(first(likelyLangs)[0])
  }

  return {
    getLangCode,
    detectLang,
  }
}
